import { PeginPaymentData, PegoutPaymentData } from '@rsksmart/flyover-sdk';

const SAT_TO_WEI = BigInt('10000000000');
const SATS_PER_BTC = BigInt('100000000');

export function weiToBtcRoundedUp(wei: bigint | string): string {
  const weiValue = typeof wei === 'bigint' ? wei : BigInt(wei);
  if (weiValue < 0n) {
    throw new Error('Negative wei value');
  }
  const sats = (weiValue + SAT_TO_WEI - 1n) / SAT_TO_WEI;
  const whole = sats / SATS_PER_BTC;
  const fraction = sats % SATS_PER_BTC;
  if (fraction === 0n) {
    return whole.toString();
  }
  return `${whole}.${fraction.toString().padStart(8, '0').replace(/0+$/, '')}`;
}

export function buildPeginQrPayload(paymentData: PeginPaymentData): string {
  return `bitcoin:${paymentData.address}?amount=${encodeURIComponent(
    paymentData.amount,
  )}`;
}

export function buildPegoutQrPayload(
  paymentData: PegoutPaymentData,
  chainId: number,
): string {
  const value = paymentData.value.toString();
  const data = encodeURIComponent(paymentData.data);
  return `ethereum:${paymentData.to}@${chainId}/depositPegOut?value=${value}&data=${data}`;
}
